import React, { useState } from "react";
import { NavHashLink } from "react-router-hash-link";
import { BiMenu } from "react-icons/bi";
import { MdClose } from "react-icons/md";
import Navlinks from "../data/navlinks";
import ProfileData from "../data/profile";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="text-white body-font fixed inset-x-0 z-50 bg-darkblue">
      <div className="mx-auto py-2 px-5 flex flex-row justify-between lg:justify-around items-center lg:py-3">
        
        {/* Logo Section */}
        <NavHashLink
          smooth
          to="/#home"
          className="flex justify-center items-center w-fit"
        >
          <img
            className="w-12 h-12 ml-3 cursor-pointer scale-125 lg:scale-150"
            src={ProfileData.logo}
            alt={ProfileData.name}
          />
        </NavHashLink>

        {/* Desktop Links */}
        <nav className="hidden md:mx-auto lg:flex flex-wrap items-center text-lg justify-center gap-12">
          {Navlinks.map((item) => (
            <NavHashLink
              key={item.title}
              smooth
              to={`/#${item.link}`}
              className="cursor-pointer hover:text-dark-orange transition-colors"
            >
              {item.title}
            </NavHashLink>
          ))}
        </nav>

        {/* Mobile Toggle */}
        <div className="lg:hidden mr-2">
          <button onClick={toggleMenu} className="p-2 text-white">
            {isMenuOpen ? <MdClose className="h-6 w-6" /> : <BiMenu className="h-6 w-6" />}
          </button>
        </div>

        {/* Resume Button */}
        <button className="hidden lg:flex items-center justify-center w-fit">
          <a
            href={ProfileData.resume}
            target="_blank"
            rel="noreferrer"
            className="leading-none text-white bg-dark-orange py-3 px-10 rounded-lg font-medium text-lg hover:bg-orange-600 transition-all"
          >
            Resume
          </a>
        </button>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="min-h-[calc(100vh-4rem)] absolute inset-x-0 top-16 z-50 lg:hidden bg-darkblue rounded-b-lg shadow-lg">
            <nav className="flex flex-col gap-y-7 text-xl items-center py-8">
              {Navlinks.map((item) => (
                <NavHashLink
                  key={item.title}
                  smooth
                  to={`/#${item.link}`}
                  onClick={() => setIsMenuOpen(false)}
                  className="cursor-pointer hover:text-dark-orange w-full text-center"
                >
                  {item.title}
                </NavHashLink>
              ))}
              <a
                href={ProfileData.resume}
                target="_blank"
                rel="noreferrer"
                className="text-white bg-dark-orange py-2.5 px-10 rounded-lg font-medium text-lg w-fit"
              >
                Resume
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;